// src/lib/access/partnerSponsoredAccess.js

import { supabase } from "../../supabaseClient";


export async function getMyPartnerSponsoredAccess() {
  const {
    data,
    error,
  } = await supabase.rpc(
    "get_my_partner_sponsored_access"
  );

  if (error) {
    throw error;
  }

  return (
    data || {
      has_access: false,
      source: "partner_cohort",
      sponsored_access_type: null,
      partner_id: null,
      cohort_id: null,
      cohort_name: null,
      access_start_date: null,
      effective_access_end: null,
      cache_expires_at: null,
    }
  );
}


export async function getPartnerSponsoredPaidJourneyResult() {
  try {
    const access =
      await getMyPartnerSponsoredAccess();

    if (
      access?.has_access !== true ||
      access?.sponsored_access_type !==
        "full_journey"
    ) {
      return null;
    }

    return {
      allowed: true,
      reason:
        "partner_sponsored_access",
      showPayment: false,

      partnerId:
        access.partner_id ||
        null,

      cohortId:
        access.cohort_id ||
        null,

      cohortName:
        access.cohort_name ||
        null,

      sponsoredAccessType:
        access.sponsored_access_type,

      effectiveAccessEnd:
        access.effective_access_end ||
        null,

      cacheExpiresAt:
        access.cache_expires_at ||
        null,
    };
  } catch (error) {
    /*
     * Partner sponsorship is only one paid-access source.
     * Fail closed for this source without preventing the
     * caller from checking once-off or referral access.
     */
    console.warn(
      "Partner-sponsored journey access could not be checked:",
      error
    );

    return null;
  }
}


export async function hasPartnerSponsoredJourneyAccessForCurrentUser() {
  const result =
    await getPartnerSponsoredPaidJourneyResult();

  return result?.allowed === true;
}